import { dehydrate } from '@tanstack/react-query';
import type { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

import { BannerSlot } from '@/core/lib/ads/ads.context';
import Query from '@/core/lib/new-architecture/query';
import makeQueryClient from '@/core/lib/query/queryClient';
import base from '@/core/lib/translation/base';
import PublicProfile from '@/core/pages/profile/PublicProfile';
import { usersPublicProfilResultSchema } from '@/core/types/profile';
import PublicLayout from '@/next/layouts/PublicLayout';

export const getServerSideProps: GetServerSideProps = async context => {
  const queryClient = makeQueryClient();
  const { params } = context;
  const { uuid } = usersPublicProfilResultSchema.cast(params, { stripUnknown: true, assert: false });

  await Query.donations.useDonations.prefetch?.({ queryClient, giver: uuid });
  await Query.categories.useCategories.prefetch?.({ queryClient });
  await Query.user.usePublicProfile.prefetch?.({ queryClient, uuid });
  const dehydratedState = dehydrate(queryClient);
  return {
    props: {
      ...(await serverSideTranslations('fr', [...base, 'profile.profile-public', 'conversation.chat'])),
      path: `/profil/public/${context.query.uuid}`,
      dehydratedState,
    },
  };
};

PublicProfile.getLayouts = page => <PublicLayout adSlot={BannerSlot.DONNONS_PROFIL_SIDE}>{page}</PublicLayout>;

export default PublicProfile;
